import React from 'react';
import clsx from 'clsx';
import { Input, Button } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';

const UuidEditor = ({
  autoFocus,
  disabled,
  error,
  onChange,
  uuid,
  maxLength,
  icon,
  size,
  className,
  placeholder,
  autoComplete = 'off',
}) => {
  const intl = useIntl();
  const placeholderText = placeholder || intl.formatMessage({ id: 'uuid.placeholder' });
  return (
    <Input
      error={error}
      autoFocus={autoFocus}
      value={uuid}
      disabled={disabled}
      className={clsx('aridhia-uuid-editor', className)}
      autoComplete={autoComplete}
      label={(
        <Button
          content={intl.formatMessage({ id: 'actions.lower.create' })}
          onClick={() => onChange(uuidv4())}
          className="aridhia-uuid-editor-button min-w-95"
        />
        )}
      placeholder={placeholderText}
      onChange={(e, { value }) => { onChange(value); }}
      fluid
      icon={icon}
      size={size}
      maxLength={maxLength}
    />
  );
};

export default UuidEditor;
